import axios from "axios";
// import { signIn } from "./constant/route";
import { toast } from "react-toastify";
const API_BASE_URL = process.env.REACT_APP_BASE_URL;

const jwtToken = localStorage.getItem("token");

const getHeadersAPI = () => {
  let header = null;
  if (jwtToken) {
    header = {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${jwtToken}`,
    };
  } else {
    header = {
      "Content-Type": "multipart/form-data",
    };
  }
  return header;
};

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    config.headers["Content-Type"] =
      config.headers["Content-Type"] || "multipart/form-data";
    if (config.data instanceof FormData) {
      delete config.headers["Content-Type"];
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("selectedUser");

      window.location.assign("/");
      toast.warning("Session expired! Please login again to continue");
    }
    if (error.response && error.response.status === 401) {
      if (window.location.pathname !== "/") {
        window.location.assign("/");
        localStorage.clear();
      }
      toast.warning(error.response.data.error || "Something went wrong...");
    }
    return Promise.reject(error);
  }
);

export default api;
